import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 2),
    textAlign: 'center',
  },
  icon: {
    marginBottom: theme.spacing(2),
    opacity: 0.5,
  },
  title: {
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    maxWidth: 400,
  },
}));
